import { jsx as _jsx } from "react/jsx-runtime";
import { NavigationItem } from "@parkschannel/ui";
import Link from "next/link";
import { useRouter } from "next/router";
import classNames from "classnames";
export function NavigationLink(props) {
    const router = useRouter();
    const current = router.pathname === props.href;
    return /*#__PURE__*/ _jsx(Link, {
        href: !props.disabled ? props.href : "#",
        onClick: props.onClick,
        children: /*#__PURE__*/ _jsx(NavigationItem, {
            disabled: props.disabled,
            isActive: current,
            icon: props.icon,
            className: classNames("text-neutral-500 text-sm font-semibold rounded-2xl", {
                "text-neutral-300": props.disabled
            }, props.className),
            children: props.children
        })
    });
}
